<template>
  <div class="s-component" :style="{ height: mainHeight }">
    <div>
      <div class="s-part-1"
        :style="{ 'background-image': `url(${part1Obj[0].bgSrc})`, width: part1Obj[0].bgWidth, height: part1Obj[0].bgHeight, top: `${part1Top}` }"
        :id="part1Id">
        <div class="s-part-1-btn">
          <div class="s-part-1-text"
            :style="{ left: part1TextStyle[0].left, top: part1TextStyle[0].top, 'font-size': part1TextStyle[0].fontSize, color: part1TextStyle[0].color }">
            {{ homeInfo.coin }}</div>
          <div class="lottery-btns">
            <div class="s-part-1-btn-lottery one btn" @click="beginLottery(1)"
              :style="{ width: lotteryBtn[0].btnWidth, height: lotteryBtn[0].btnHeight, 'background-image': `url(${lotteryBtn[0].btnSrc})`, left: lotteryBtn[0].left, bottom: lotteryBtn[0].bottom }">
            </div>
            <div class="s-part-1-btn-lottery ten btn" @click="beginLottery(10)"
              :style="{ width: lotteryTenBtn[0].btnWidth, height: lotteryTenBtn[0].btnHeight, 'background-image': `url(${lotteryTenBtn[0].btnSrc})`, left: lotteryTenBtn[0].left, bottom: lotteryTenBtn[0].bottom }">
            </div>
          </div>
          <div class="s-part-1-btn-buy btn" @click="showCount"
            :style="{ width: part1Btn[0].btnWidth, height: part1Btn[0].btnHeight, 'background-image': `url(${part1Btn[0].btnSrc})`, left: part1Btn[0].left, bottom: part1Btn[0].bottom }">
          </div>
          <div class="s-part-1-btn-rule btn" @click="openRule"
            :style="{ width: part1Rule[0].btnWidth, height: part1Rule[0].btnHeight, 'background-image': `url(${part1Rule[0].btnSrc})`, left: part1Rule[0].left, bottom: part1Rule[0].bottom }">
          </div>
          <div class="s-part-1-btn-record btn" @click="openLog(1)"
            :style="{ width: part1Record[0].btnWidth, height: part1Record[0].btnHeight, 'background-image': `url(${part1Record[0].btnSrc})`, left: part1Record[0].left, bottom: part1Record[0].bottom }">
          </div>
        </div>
        <div class="s-part1-recive-box"
          :style="{ width: prat1ReciveTextBox[0].width, height: prat1ReciveTextBox[0].height, left: prat1ReciveTextBox[0].left, bottom: prat1ReciveTextBox[0].bottom }">
          <div v-for="(item, index) in part1ReciveGiftList" :key="index"
            :style="{ fontSize: prat1ReciveTextBox[0].fontSize,color: prat1ReciveTextBox[0].color }">
            {{ item.condition_ret.actual_val }}/{{ item.condition_ret.expect_val }}
          </div>
        </div>
        <div class="s-part1-recive-box"
          :style="{ width: prat1ReciveGiftBox[0].width, height: prat1ReciveGiftBox[0].height, left: prat1ReciveGiftBox[0].left, bottom: prat1ReciveGiftBox[0].bottom }">
          <div v-for="(item, index) in part1ReciveGiftList" :key="index"
            @click="reciveGiftFunc(activityId3, item, 'getGift3Info')"
            :style="{ width: prat1ReciveGiftBox[0].btnWidth, height: prat1ReciveGiftBox[0].btnHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
      <div class="s-part-2"
        :style="{ 'background-image': `url(${part2Obj[0].bgSrc})`, width: part2Obj[0].bgWidth, height: part2Obj[0].bgHeight, top: `${part2Top}` }"
        :id="part2Id">
        <img class="s-part-2-btn" @click="clickTopBtn(activityId10, weaponInfo, 'getHomeInfo')"
          :style="{ width: part2Obj[0].itemWidth, height: part2Obj[0].itemHeight, left: part2Obj[0].left, bottom: part2Obj[0].bottom }"
          :src="part2Obj[0].btnSrc" alt="" />
      </div>
      <!-- 签到活动 -->
      <div class="s-part-3"
        :style="{ 'background-image': `url(${part3Obj[0].bgSrc})`, width: part3Obj[0].bgWidth, height: part3Obj[0].bgHeight, top: `${part3Top}` }"
        :id="part3Id">
        <div class="s-part-3-item s-part3-gift">
          <div v-for="(item, index) in part3List.slice(0, 1)" style="position: absolute;" :key="index"
            @click="reciveGiftFunc(activityId4, item, ['getGift4Info', 'getHomeInfo'])"
            :style="{ width: part3Obj[0].itemWidth, height: part3Obj[0].itemHeight, left: part3BtnsFirst[0].left, bottom: part3BtnsFirst[0].bottom }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
        <div class="s-part-3-other-box s-part3-gift"
          :style="{ width: part3BtnsOther[0].boxWidth, height: part3BtnsOther[0].boxHeight, left: part3BtnsOther[0].left, bottom: part3BtnsOther[0].bottom }">
          <div v-for="(item, index) in part3List.slice(1, 7)"
            :style="{ width: part3Obj[0].itemWidth, height: part3Obj[0].itemHeight }" :key="index"
            class="s-part-3-other-item" @click="reciveGiftFunc(activityId4, item, ['getGift4Info', 'getHomeInfo'])">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
      <!-- 累计登录活动   -->
      <div class="s-part-4"
        :style="{ 'background-image': `url(${part4Btns[0].bgSrc})`, width: part4Btns[0].bgWidth, height: part4Btns[0].bgHeight, top: `${part4Top}` }"
        :id="part4Id">
        <div class="s-part-4-login-count"
          :style="{ fontSize: part4LoginCount[0].fontSize, color: part4LoginCount[0].color, left: part4LoginCount[0].left, bottom: part4LoginCount[0].bottom }">
          {{ loginCount }}</div>
        <div class="s-part-4-item-box"
          :style="{ width: part4Btns[0].boxWidth, height: part4Btns[0].boxHeight, bottom: part4Btns[0].bottom, left: part4Btns[0].left }">
          <div v-for="(item, index) in part4List" :key="index" class="s-part-4-item"
            @click="reciveGiftFunc(activityId5, item, ['getGift5Info', 'getHomeInfo'])"
            :style="{ width: part4Btns[0].itemWidth, height: part4Btns[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
      <!-- 周末福利活动 -->
      <div class="s-part-5"
        :style="{ 'background-image': `url(${part5Btns[0].bgSrc})`, width: part5Btns[0].bgWidth, height: part5Btns[0].bgHeight, top: `${part5Top}` }"
        :id="part5Id">
        <div class="s-part-5-item-box"
          :style="{ width: part5Btns[0].boxWidth, height: part5Btns[0].boxHeight, bottom: part5Btns[0].bottom, left: part5Btns[0].left }">
          <div v-for="(item, index) in part5List" :key="index" class="s-part-5-item"
            @click="reciveGiftFunc(activityId6, item, ['getGift6Info', 'getHomeInfo'])"
            :style="{ width: part5Btns[0].itemWidth, height: part5Btns[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
      <!-- 周期任务活动 -->
      <div class="s-part-6"
        :style="{ 'background-image': `url(${part6Btns[0].bgSrc})`, width: part6Btns[0].bgWidth, height: part6Btns[0].bgHeight, top: `${part6Top}` }"
        :id="part6Id">
        <div class="s-part-6-text s-part-6-text-daily"
          :style="{ width: part6Text[0].DailyTaskWidth, height: part6Text[0].DailyTaskHeight, bottom: part6Text[0].DailyTaskBottom, left: part6Text[0].DailyTaskLeft, color: part6Text[0].color, fontSize: part6Text[0].fontSize }">
          <div class="s-part-6-text-item-title" v-for="(item, index) in part6List.slice(0, 3)"
            v-show="item.condition_ret" :key="index">{{ item.condition_ret?.actual_val }}/{{
            item.condition_ret?.expect_val }}</div>
        </div>
        <div class="s-part-6-text s-part-6-text-weekly"
          :style="{ width: part6Text[0].WeeklyTaskWidth, height: part6Text[0].WeeklyaskHeight, bottom: part6Text[0].WeeklyTaskBottom, left: part6Text[0].WeeklyTaskLeft, color: part6Text[0].color, fontSize: part6Text[0].fontSize }">
          <div class="s-part-6-text-item-title" v-for="(item, index) in part6List.slice(3, 5)"
            v-show="item.condition_ret" :key="index">{{ item.condition_ret?.actual_val }}/{{
            item.condition_ret?.expect_val }}</div>
        </div>
        <div class="s-part-6-text s-part-6-text-special"
          :style="{ width: part6Text[0].SpecialTaskWidth, height: part6Text[0].SpecialaskHeight, bottom: part6Text[0].SpecialTaskBottom, left: part6Text[0].SpecialTaskLeft, color: part6Text[0].color, fontSize: part6Text[0].fontSize }">
          <div class="s-part-6-text-item-title" v-for="(item, index) in part6List.slice(5, 8)"
            v-show="item.condition_ret" :key="index">{{ item.condition_ret?.actual_val }}/{{
            item.condition_ret?.expect_val }}</div>
        </div>
        <div class="s-part-6-daily s-part-6-item-box"
          :style="{ width: part6Btns[0].DailyTaskWidth, height: part6Btns[0].DailyTaskHeight, bottom: part6Btns[0].DailyTaskBottom, left: part6Btns[0].DailyTaskLeft }">
          <div v-for="(item, index) in part6List.slice(0, 3)" :key="index" class="s-part-6-item" :name="item.name"
            @click="reciveGiftFunc(activityId7, item, ['getGift7Info', 'getHomeInfo'])"
            :style="{ width: part6Btns[0].itemWidth, height: part6Btns[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
        <div class="s-part-6-weekly s-part-6-item-box"
          :style="{ width: part6Btns[0].WeeklyTaskWidth, height: part6Btns[0].WeeklyTaskHeight, bottom: part6Btns[0].WeeklyTaskBottom, left: part6Btns[0].WeeklyTaskLeft }">
          <div v-for="(item, index) in part6List.slice(3, 5)" :key="index" class="s-part-6-item" :name="item.name"
            @click="reciveGiftFunc(activityId7, item, ['getGift7Info', 'getHomeInfo'])"
            :style="{ width: part6Btns[0].itemWidth, height: part6Btns[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
        <div class="s-part-6-daily s-part-6-item-box"
          :style="{ width: part6Btns[0].SpecialTaskWidth, height: part6Btns[0].SpecialTaskHeight, bottom: part6Btns[0].SpecialTaskBottom, left: part6Btns[0].SpecialTaskLeft }">
          <div v-for="(item, index) in part6List.slice(5, 8)" :key="index" class="s-part-6-item" :name="item.name"
            @click="reciveGiftFunc(activityId7, item, ['getGift7Info', 'getHomeInfo'])"
            :style="{ width: part6Btns[0].itemWidth, height: part6Btns[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
      <!-- 好友集结 -->
      <div class="s-part-7"
        :style="{ 'background-image': `url(${part7Obj[0].bgSrc})`, width: part7Obj[0].bgWidth, height: part7Obj[0].bgHeight, top: `${part7Top}` }"
        :id="part7Id">
        <div class="s-part-7-invite-box"
          :style="{ width: part7Btns[0].inviteWidth, height: part7Btns[0].inviteHeight, left: part7Btns[0].inviteLeft, bottom: part7Btns[0].inviteBottom }">
          <img class="s-btn" :src="part7Obj[0].inviteSrc" @click="inviteFunc(activityId8, 'getHomeInfo')"
            :style="{ width: part7Obj[0].itemWidth, height: part7Obj[0].itemHeight }" alt="" />
          <img class="s-btn" :src="part7Obj[0].joinSrc" @click="joinFunc(activityId8)"
            :style="{ width: part7Obj[0].itemWidth, height: part7Obj[0].itemHeight }" alt="" />
        </div>
        <div class="s-part-7-invite-text"
          :style="{ fontSize: part7Text[0].fontSize, color: part7Text[0].color, left: part7Text[0].inviteTextLeft, bottom: part7Text[0].inviteTextBottom }">
          当前队伍人数（{{ homeInfo.team_count }}/{{ homeInfo.team_max_count }}）</div>
        <div class="s-part-7-task-box"
          :style="{ width: part7Btns[0].taskWidth, height: part7Btns[0].taskHeight, left: part7Btns[0].taskLeft, bottom: part7Btns[0].taskBottom }">
          <div class="s-part-7-task-item" v-for="(item, index) in part7MissionList" :key="index"
            @click="reciveMissionFunc(activityId8, item, ['getGift8Info', 'getHomeInfo'])"
            :style="{ width: part7Obj[0].itemWidth, height: part7Obj[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
      <!-- 新回活动 -->
      <div class="s-part-8"
        :style="{ 'background-image': `url(${part8Obj[0].bgSrc})`, width: part8Obj[0].bgWidth, height: part8Obj[0].bgHeight, top: `${part8Top}` }"
        :id="part8Id">
        <div class="s-part-8-item-box"
          :style="{ width: part8Obj[0].boxWidth, height: part8Obj[0].boxHeight, left: part8Obj[0].left, bottom: part8Obj[0].bottom }">
          <div class="s-part-8-item" v-for="(item, index) in part8List" :key="index"
            @click="reciveGiftFunc(activityId9, item, ['getGift9Info', 'getHomeInfo'])"
            :style="{ width: part8Obj[0].itemWidth, height: part8Obj[0].itemHeight }">
            <img class="s-btn" v-if="item.status === 0" :src="receiveBtn0.src" alt="" />
            <img class="s-btn" v-if="item.status === 1" :src="receiveBtn1.src" alt="" />
            <img class="s-btn hv-highlight" v-if="item.status === 2" :src="receiveBtn2.src" alt="" />
            <img class="s-btn" v-if="item.status === 3" :src="receiveBtn3.src" alt="" />
            <img class="s-btn" v-if="item.status === 4" :src="receiveBtn4.src" alt="" />
          </div>
        </div>
      </div>
    </div>
    <ModalReceive ref="ModalReceive" />
    <ModalConfirm ref="ModalConfirm" />
    <modal-rule ref="ModalRule" />
    <!-- 历史 -->
    <ModalReceiveLog ref="ModalReceiveLog" />
    <!-- 分享 -->
    <ModalShareNew :activityId="activityId8" ref="ModalShareNew" @joinSuccess="joinSuccess" />
    <!-- 加入其他队伍 -->
    <ModalJoinTeam ref="ModalJoinTeam" @joinSuccess="joinSuccess" />
    <VersionActivitySliderBar ref="VersionActivitySliderBar" />
    <ModalAddress ref="ModalAddress" />
    <slot></slot>
  </div>
</template>

<script>
import ModalReceive from '../_components/ModalReceive.vue'
import ModalJoinTeam from '../_components/ModalJoinTeam.vue'
import ModalShareNew from '../_components/ModalShareNew.vue'
import ModalAddress from '../_components/ModalAddress.vue'
import VersionActivitySliderBar from './_components/VersionActivitySliderBar.vue'
import ModalConfirm from '../_components/ModalConfirm.vue'
import ModalReceiveLog from '../_components/ModalReceiveLog.vue'
import ModalRule from '../_components/ModalRule.vue'

export default {
  name: 'SVersionActivity',
  components: {
    // SButtonShare,
    VersionActivitySliderBar,
    ModalJoinTeam,
    ModalShareNew,
    ModalReceiveLog,
    ModalRule,
    // ModalPointLog,
    ModalReceive,
    ModalAddress,
    ModalConfirm
  },
  props: {
    ruleId: {
      type: String,
      required: true
    },
    part4Btns: {
      type: Array,
      required: true,
      default: () => []
    },
    part4LoginCount: {
      type: Array,
      required: true,
      default: () => []
    },
    part4Top: {
      type: String,
      required: true
    },
    part5Btns: {
      type: Array,
      required: true,
      default: () => []
    },
    part5Top: {
      tyze: String,
      required: true
    },
    part6Top: {
      type: String,
      required: true
    },
    part6Btns: {
      type: Array,
      required: true,
      default: () => []
    },
    part6Text: {
      type: Array,
      required: true,
      default: () => []
    },
    part8Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part8Top: {
      type: String,
      required: true
    },
    part1Id: {
      type: String,
      required: true
    },
    part2Id: {
      type: String,
      required: true
    },
    part3Id: {
      type: String,
      required: true
    },
    part4Id: {
      type: String,
      required: true
    },
    part5Id: {
      type: String,
      required: true
    },
    part6Id: {
      type: String,
      required: true
    },
    part7Id: {
      type: String,
      required: true
    },
    part7Top: {
      type: String,
      required: true
    },
    part7Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part7Btns: {
      type: Array,
      required: true,
      default: () => []
    },
    part7Text: {
      type: Array,
      required: true,
      default: () => []
    },
    mainHeight: {
      type: String,
      required: true
    },
    part8Id: {
      type: String,
      required: true
    },
    // 一键领取活动
    part1Top: {
      type: String,
      required: true
    },
    part2Top: {
      type: String,
      required: true
    },
    part1Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    lotteryCost: {
      type: Number,
      required: true
    },
    part2Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part1Btn: {
      type: Array,
      required: true,
      default: () => []
    },
    lotteryBtn: {
      type: Array,
      required: true,
      default: () => []
    },
    lotteryTenBtn: {
      type: Array,
      required: true,
      default: () => []
    },
    prat1ReciveGiftBox: {
      type: Array,
      required: true,
      default: () => []
    },
    prat1ReciveTextBox: {
      type: Array,
      required: true,
      default: () => []
    },
    part1TextStyle: {
      type: Array,
      required: true,
      default: () => []
    },
    part1Record: {
      type: Array,
      required: true,
      default: () => []
    },
    part1Rule: {
      type: Array,
      required: true,
      default: () => []
    },
    part3Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part3Top: {
      type: String,
      required: true
    },
    part3BtnsOther: {
      type: Array,
      required: true,
      default: () => []
    },
    part3BtnsFirst: {
      type: Array,
      required: true,
      default: () => []
    },
    // ===== 任务 ID 配置 =====
    // 抽奖活动ID
    activityId1: {
      type: String,
      default: ''
    },
    // 点券购买活动ID
    activityId2: {
      type: String,
      default: ''
    },
    // 累计抽奖活动ID
    activityId3: {
      type: String,
      default: ''
    },
    // 签到活动ID
    activityId4: {
      type: String,
      default: ''
    },
    // 累登活动ID
    activityId5: {
      type: String,
      default: ''
    },
    // 周末福利活动ID
    activityId6: {
      type: String,
      default: ''
    },
    // 周期任务活动ID
    activityId7: {
      type: String,
      default: ''
    },
    // 组队任务活动ID
    activityId8: {
      type: String,
      default: ''
    },
    // 新回活动ID
    activityId9: {
      type: String,
      default: ''
    },
    // 武器购买活动ID
    activityId10: {
      type: String,
      default: ''
    },
    // ===== text color =====
    textColorLevel1: {
      type: String,
      default: '#333'
    },
    textColorLevel2: {
      type: String,
      default: '#666'
    },
    textColorLevel3: {
      type: String,
      default: '#999'
    },
    textColorActive: {
      type: String,
      default: '#fff'
    },
    miniBtnColor: {
      type: String,
      default: '#608351'
    },

    // ===== 抽奖Btn =====
    // drawActiveItem: {
    //   type: String,
    //   default: ''
    // },
    drawBgColor: {
      type: String,
      default: '#FFBE57'
    },
    drawBgColorActive: {
      type: String,
      default: '#FFE8BB'
    },

    // ===== 登录领取Btn =====
    receiveBtn0: {
      type: Object,
      required: true
    },
    receiveBtn1: {
      type: Object,
      required: true
    },
    receiveBtn2: {
      type: Object,
      required: true
    },
    receiveBtn3: {
      type: Object,
      required: true
    },
    receiveBtn4: {
      type: Object,
      required: true
    },

    // ===== 侧边栏 =====
    textColor: {
      type: String,
      default: '#FDEDC2'
    },
    sliderTop: {
      type: String,
      default: '15%'
    },
    sideBarNavShowDistance: {
      type: String,
      default: '1000'
    },
    textHoverColor: {
      type: String,
      default: '#FDEDC2'
    },
    sideBarNavText: {
      type: Array,
      required: true,
      default: () => []
    },
    sliderBox: {
      type: Array,
      required: true,
      default: () => []
    },
    // ===== modal =====
    modalBg: {
      type: Object,
      default: () => {
      }
    },
    modalCloseIcon: {
      type: Object,
      default: () => {
      }
    },
    modalTitleStyle: {
      type: String,
      default: '{}'
    },
    modalTextStyle: {
      type: String,
      default: '{}'
    },
    modalConfirmBtnStyle: {
      type: String,
      default: '{}'
    },
    modalCancelBtnStyle: {
      type: String,
      default: '{}'
    }

  },
  data() {
    return {
      part1ReciveGiftList: [
        {
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        }
      ],
      swiperOption: {
        slidesPerView: Number(this.part4SlidesPerView),
        spaceBetween: Number(this.part4SpaceBetween),
        autoplay: {
          disableOnInteraction: false,
          delay: 3000 // 3秒切换一次
        },
        // centeredSlides: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      wdFrom: '',
      from: '',
      part1Info: {
        id: '',
        icon: '',
        status: 0
      },
      sliderData: {},
      part2Info: [],
      part3Info: [],

      point: 0,
      pageInfo: {
        status: false
      },
      shopAct: {
        groups: []
      },
      // 登录活动
      loginAct: {
        groups: [{ status: 0 }]
      },
      lotteryAct: {
        award: {
          groups: []
        }
      },
      taskAct: {
        groups: []
      },
      lotteryTimes: 0,

      part3List: [],
      part4List: [],
      loginCount: 0,
      part5List: [],
      part6List: [
        {
          id: 4943,
          name: "完成任意PVP对局且胜利",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          id: 4944,
          name: "完成PVE任意难度对局",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          id: 4945,
          name: "完成每日所有任务",
          status: 0
        },
        {
          id: 4946,
          name: "本周在PVP团队模式中累计淘汰50名敌人",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          id: 4947,
          name: "本周累计获取3场爆破模式（不含天梯）胜利",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          id: 4948,
          name: "在PVE任意模式中累计击杀怪物1500只（限1次）",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          id: 4949,
          name: "通关5次任意PVE噩梦难度（限1次）",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        },
        {
          id: 4950,
          name: "每周在游戏内累计消费600点券",
          status: 0,
          condition_ret: {
            actual_val: 0,
            expect_val: 0
          }
        }
      ],
      part7MissionList: [],
      part8List: [],
      homeInfo: {},
      coinInfo: {},
      weaponInfo: {}
    }
  },
  provide() {
    return {
      $MainWrap: this
    }
  },

  inject: {
    eventBus: {
      default: null
    }
  },
  computed: {
    requestAPI() {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  async mounted() {
    const { from, wdFrom } = this.$route.query
    this.from = from
    this.wdFrom = wdFrom
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.init)
      // 登出操作添加
      this.eventBus.on('signOut', this.init)
    }
    await this.init()
    // this.openRule()
  },
  methods: {
    joinSuccess() {
      this.getHomeInfo()
      this.getGift8Info()
    },
    async signFunc() {
      await this.requestAPI({
        url: '/v1/uni/official/sign',
        method: 'get',
        params: {
          a_id: this.activityId4
        }
      }).then(() => {
      }).catch((err) => {
        console.error(err)
      })
    },
    inviteFunc(activityId) {
      this.$refs.ModalShareNew.open({
        joinUrl: '/v1/uni/official/team-join',
        giftUrl: '/v1/uni/official/team-award',
        key: '加入',
        activityId: activityId,
        tipText: '好兄弟，快来帮我助力！真的很想要！是兄弟就来《生死狙击2》！>> '
      })
    },
    joinFunc(activityId) {
      console.log(activityId, 'activityId')
      this.$refs.ModalJoinTeam.open({
        activityId: activityId
      })
    },
    myAlert(str, title = '提示', showCancel = '', sb, eb) {
      this.$alert(str, title, {
        customClass: 'my_alert',
        confirmButtonText: '确定',
        cancelButtonClass: showCancel,
        showCancelButton: showCancel,
        callback: action => {
          if (action === 'confirm') {
            sb && sb()
          } else {
            eb && eb()
          }
        }
      })
    },
    // 购买前确认
    clickTopBtn(a_id, obj, fn, count) {
      if (!window.$checkLogin()) return
      this.$confirm(`是否消耗点券购买${count ? `【${count}】份` : ''}${obj.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reciveGift(a_id, obj, fn, '', count)
      }).catch((err) => {
        console.error(err)
        // this.$message({
        //   message: err.msg || '系统错误',
        //   type: "error"
        // })
      })
    },
    showCount() {
      if (!window.$checkLogin()) return
      this.$prompt('请输入购买数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^([1-9]|10)$/,
        inputErrorMessage: '请输入1-10之间的数字',
        inputType: 'number',
        inputValue: 1
      }).then(({ value }) => {
        // 校验输入的数字是否在1-10之间
        if (value < 1 || value > 10) {
          this.$message.error('请输入1-10之间的数字')
          return
        }
        this.clickTopBtn(this.activityId2, this.coinInfo, 'getHomeInfo', value)
      }).catch(() => {
        // 用户点击取消按钮
      })
    },
    // // 领取前确认
    reciveGiftFunc(a_id, obj, fn, str) {
      console.log(obj, 'obj')
      if (!window.$checkLogin()) return
      // if (a_id === env.part5) {
      // this.reciveGift(a_id, obj, fn, str)
      // } else {
      if (obj.status === 0) {
        this.$message({
          message: '不在活动时间内',
          type: "error"
        })
        return
      }
      if (obj.status === 1) {
        this.$message({
          message: '未达到领取条件',
          type: "error"
        })
        return
      }
      if (obj.status === 2) {
        this.reciveGift(a_id, obj, fn, str)
      }
      // }
    },
    // // 购买、领取
    reciveGift(activityId, item, fn, str, count) {
      const params = {
        a_id: activityId,
        g_id: item.id
      }
      if (count) {
        params.amount = count
      }
      this.requestAPI({
        url: '/v1/uni/receive',
        method: 'get',
        params
      }).then((res) => {
        console.log(res)
        if (str === 'materials') {
          const arr = []
          item.materials && item.materials.forEach((i) => {
            arr.push(`${i.name}*${i.amount}`)
          })
          this.myAlert(`恭喜您获得 ${arr.join('、')}`)
        } else {
          this.myAlert(`恭喜您获得 ${item.desc}`)
        }
        if (fn && typeof fn === 'string') {
          fn && this[fn] && this[fn]()
        } else if (fn && Array.isArray(fn)) {
          fn.forEach(item => {
            this[item] && this[item]()
          })
        }
      }).catch((err) => {
        console.error(err)
        this.$message({
          message: err.msg || '系统错误',
          type: "error"
        })
      })
    },
    reciveMissionFunc(activityId, item, fn, str) {
      console.log(item, 'item')
      if (!window.$checkLogin()) return
      if (item.status === 0) {
        this.$message({
          message: '不在活动时间内',
          type: "error"
        })
      }
      if (item.status === 1) {
        this.$message({
          message: '未达到领取条件',
          type: "error"
        })
        return
      }
      if (item.status === 2) {
        this.requestAPI({
          url: '/v1/uni/official/team-award',
          method: 'get',
          params: {
            a_id: activityId,
            g_id: item.id
          }
        }).then((res) => {
          console.log(res)
          if (str === 'materials') {
            const arr = []
            item.materials && item.materials.forEach((i) => {
              arr.push(`${i.name}*${i.amount}`)
            })
            this.myAlert(`恭喜您获得 ${arr.join('、')}`)
          } else {
            this.myAlert(`恭喜您获得 ${item.desc}`)
          }
          if (fn && typeof fn === 'string') {
            fn && this[fn] && this[fn]()
          } else if (fn && Array.isArray(fn)) {
            fn.forEach(item => {
              this[item] && this[item]()
            })
          }
        }).catch((err) => {
          console.error(err)
          this.$message({
            message: err.msg || '系统错误',
            type: "error"
          })
        })
      }
    },
    async init() {
      await this.getHomeInfo() // 获取首页信息&余额&组队信息
      this.getGift2Info() // 获取点券购买活动
      this.getGift3Info() // 获取累计抽奖活动
      const token = localStorage.getItem('activeToken')
      if (token) {
        await this.signFunc()
      }
      this.getGift4Info() // 获取签到活动
      this.getGift5Info() // 获取累登活动
      this.getGift6Info() // 获取周末福利活动
      this.getGift7Info() // 获取周期任务活动
      this.getGift8Info() // 获取组队任务活动
      this.getGift9Info() // 获取新回活动
      this.getGift10Info() // 获取武器购买活动
      this.$refs.ModalShareNew.getShareCode(this.activityId8)
    },
    openRule() {
      this.$refs.ModalRule.open(this.ruleId)
    },
    // 开始抽奖
    beginLottery(count) {
      if (!window.$checkLogin()) return
      if (this.homeInfo.coin < this.lotteryCost * count) {
        this.$message.error('抽奖次数不足')
        return
      }
      this.requestAPI({
        url: '/v1/uni/multiLottery',
        method: 'get',
        params: { a_id: this.activityId1, count: count }
      }).then(res => {
        const arr = []
        // type: 1 游戏道具 2 实物奖励 3 虚拟积分
        res.forEach((i) => {
          i.materials && i.materials.forEach((j) => {
            if (j.type !== 3) { // 虚拟积分不显示
              arr.push(`${j.name}*${j.amount}`)
            }
          })
        })
        this.myAlert(`恭喜您获得 ${arr.join('、')}`)
        this.getGift3Info()
        this.getHomeInfo() // 刷新余额和首页信息
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 获取首页信息
    async getHomeInfo() {
      await this.requestAPI({
        url: '/v1/uni/official/team-info',
        method: 'get',
        params: { a_id: this.activityId8 }
      }).then(res => {
        console.log('获取首页信息', res)
        // res = {
        //   coin : 0,
        //   role_name  :  "",
        //   team_code : "",
        //   team_count : 0,
        //   team_max_count : 5,
        // }
        this.homeInfo = res
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 点券购买活动
    getGift2Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId2 }
      }).then(res => {
        console.log('点券购买活动', res)
        this.coinInfo = res.groups[0] || {}
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 武器购买活动
    getGift10Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId10 }
      }).then(res => {
        console.log('点券购买活动', res)
        this.weaponInfo = res.groups[0] || {}
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 累计抽奖活动
    getGift3Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId3 }
      }).then(res => {
        console.log('----累计抽奖活动----', res)
        this.part1ReciveGiftList = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 签到活动
    getGift4Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId4 }
      }).then(res => {
        console.log('----签到活动----', res)
        this.part3List = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 累登活动
    getGift5Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId5 }
      }).then(res => {
        console.log('----累登活动----', res)
        this.part4List = res.groups || []
        this.loginCount = (res.groups && res.groups.length > 0) ? res.groups[res.groups.length - 1].condition_ret.actual_val : 0
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 周末福利活动
    getGift6Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId6 }
      }).then(res => {
        console.log('----周末福利活动----', res)
        this.part5List = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 周期任务活动
    getGift7Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId7 }
      }).then(res => {
        console.log('----周期任务活动----', res)
        this.part6List = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 组队任务活动
    getGift8Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId8 }
      }).then(res => {
        console.log('----组队任务活动----', res)
        this.part7MissionList = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // ----新回活动----
    getGift9Info() {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId9 }
      }).then(res => {
        console.log('----新回活动----', res)
        this.part8List = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    /**
     * 打开领取弹窗
     * @param awardsList 奖励列表 [{name: '', icon: ''}]
     * @param showAddress 是否显示地址
     */
    openReceiveModal(awardsList, showAddress = false) {
      this.$refs.ModalReceive.open(awardsList, showAddress)
    },
    confirm(options) {
      this.$refs.ModalConfirm.open(options)
    },
    /**
     * 打开记录弹窗
     * @param type 2: 抽奖记录 3: 领取记录 4: 兑换记录
     */
    openLog(type) {
      if (!window.$checkLogin()) return
      // const titleMap = {
      //   1: '购买记录',
      //   2: '抽奖记录',
      //   4: '抽奖记录'
      // }
      // const title = titleMap[type]
      const title = '记录'
      // console.log('---openLog---', type, title)
      this.$refs.ModalReceiveLog.open({
        title,
        activityId: this[`activityId${type}`],
        needAddress: true
      })
    },
    /**
     * 打开积分记录弹窗
     */
    // openPointLog () {
    //   if (!window.$checkLogin()) return
    //   const options = {
    //     activityId: this.activityId4
    //   }
    //   this.$refs.ModalPointLog.open(options)
    // },
    openAddress() {
      this.$refs.ModalAddress.open(this.activityId3)
    }
  }
}
</script>
<style lang="scss" scoped>
.s-component {
  position: relative;
  background-color: rgba(0, 0, 0, .1);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 4000px;
  img {
    width: 100%;
    height: 100%;
  }
}

.mini-color-btn {
  text-decoration: underline;
  display: inline-block;
  width: 95px;
  height: 30px;
  border: 1PX solid;
  line-height: 28px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}

.s-part-1,
.s-part-2,
.s-part-3,
.s-part-4,
.s-part-5,
.s-part-6,
.s-part-7,
.s-part-8 {
  position: absolute;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.s-part-1 {

  .s-part-1-btn,
  .s-part-1-gift {
    display: flex;
    justify-content: center;

    .btn {
      position: absolute;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .s-part-1-text {
      position: absolute;
    }
  }

  .s-part1-recive-box {
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;

  }
}

.s-part-2 {

  .s-part-2-btn {
    position: absolute;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

.s-part-3 {
  .s-part-3-other-box {
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: space-between;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    .s-part-3-other-item {
      display: flex;
      justify-content: center;
      align-items: center;

      &:nth-child(n+4) {
        margin-top: auto;
      }
    }
  }
}

.s-part-4 {
  .s-part-4-item-box {
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .s-part-4-login-count {
    position: absolute;
  }
}

.s-part-5 {
  .s-part-5-item-box {
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

.s-part-6 {
  .s-part-6-item-box {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .s-part-6-text {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.s-part-7 {
  .s-part-7-invite-box {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .s-part-7-invite-text {
    position: absolute;
  }

  .s-part-7-task-box {
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
  }
}

.s-part-8 {
  .s-part-8-item-box {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
